var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "card-content" },
      [
        _c("div", { staticClass: "content" }, [
          _c("p", {}, [_vm._v("Seleccione los documentos que desea cargar")]),
          _vm._v(" "),
          _vm.forceHerencia
            ? _c("p", { staticClass: "is-size-7 has-text-primary" }, [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v(" "),
                _c("b", [_vm._v("Nota:")]),
                _vm._v(
                  " Los documentos heredarán por defecto los permisos de la carpeta actual"
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "b-notification",
          {
            attrs: { type: "is-warning", active: _vm.isActive },
            on: {
              "update:active": function ($event) {
                _vm.isActive = $event
              },
              click: function ($event) {
                _vm.isActive = !_vm.isActive
              },
            },
          },
          [_vm._v(_vm._s(_vm.error))]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "columns" }, [
          _vm.files.length == 0
            ? _c(
                "div",
                { staticClass: "column" },
                [
                  _c(
                    "b-field",
                    { attrs: { position: "is-centered" } },
                    [
                      _c(
                        "b-upload",
                        {
                          attrs: {
                            "drag-drop": "",
                            multiple: "",
                            expanded: "",
                          },
                          model: {
                            value: _vm.files,
                            callback: function ($$v) {
                              _vm.files = $$v
                            },
                            expression: "files",
                          },
                        },
                        [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              { staticClass: "content has-text-centered" },
                              [
                                _c("p", [
                                  _c("i", { staticClass: "fas fa-copy fa-2x" }),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "fas fa-plus fa-2x" }),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "is-size-7" }, [
                                  _vm._v(
                                    "Arrastre uno o más archivos, o haga clic"
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.files.length > 0
            ? _c("div", { staticClass: "column" }, [
                _c("table", { staticClass: "table is-narrow is-fullwidth" }, [
                  _c("thead", [
                    !_vm.isUploading && !_vm.isDone
                      ? _c(
                          "th",
                          {
                            staticClass: "has-text-centered",
                            attrs: { width: "35" },
                          },
                          [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  label: "Quitar de la lista",
                                  position: "is-right",
                                },
                              },
                              [_c("i", { staticClass: "fas fa-trash" })]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("th", [_vm._v("Nombre")]),
                    _vm._v(" "),
                    _c(
                      "th",
                      { attrs: { width: "65" } },
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "Heredar permisos de carpeta padre",
                              position: "is-left",
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-users cog" }),
                            _c("i", {
                              staticClass: "fas fa-level-down-alt fa-fw",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      { attrs: { width: "35" } },
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "Documento confidencial",
                              position: "is-left",
                            },
                          },
                          [_c("i", { staticClass: "fas fa-lock fa-fw" })]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    [
                      _vm._l(_vm.files, function (file, i) {
                        return _c("tr", { key: `file-${i}` }, [
                          !_vm.isUploading && !_vm.isDone
                            ? _c("td", { staticClass: "has-text-centered" }, [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeFromFiles(i)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fas fa-times-circle",
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(file.name) +
                                    "\n                  "
                                ),
                                _vm.filesSucceded.includes(file.name)
                                  ? _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          type: "is-success",
                                          label: "Subido correctamente",
                                          position: "is-right",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "has-text-success" },
                                          [
                                            _vm._v("\n                       "),
                                            _c("i", {
                                              staticClass:
                                                "fas fa-check-circle",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.filesFailed.includes(file.name)
                                  ? _c(
                                      "b-tooltip",
                                      {
                                        attrs: {
                                          type: "is-danger",
                                          label: _vm.filesErrors[file.name],
                                          position: "is-right",
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "has-text-danger" },
                                          [
                                            _vm._v("\n                       "),
                                            _c("i", {
                                              staticClass:
                                                "fas fa-times-circle",
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "has-text-centered" },
                            [
                              _c("b-checkbox", {
                                attrs: {
                                  "native-value": file.name,
                                  disabled:
                                    _vm.isUploading ||
                                    _vm.isDone ||
                                    _vm.forceHerencia,
                                },
                                model: {
                                  value: _vm.permisos_heredados,
                                  callback: function ($$v) {
                                    _vm.permisos_heredados = $$v
                                  },
                                  expression: "permisos_heredados",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("b-checkbox", {
                                attrs: {
                                  "native-value": file.name,
                                  disabled: _vm.isUploading || _vm.isDone,
                                },
                                model: {
                                  value: _vm.confidenciales,
                                  callback: function ($$v) {
                                    _vm.confidenciales = $$v
                                  },
                                  expression: "confidenciales",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      }),
                      _vm._v(" "),
                      _vm.files.length == 0 ? _c("tr", [_vm._m(1)]) : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _vm.files.length > 0 && !_vm.isUploading && !_vm.isDone
                  ? _c(
                      "div",
                      [
                        _c(
                          "b-field",
                          { attrs: { position: "is-centered" } },
                          [
                            _c(
                              "b-upload",
                              {
                                attrs: {
                                  "drag-drop": "",
                                  multiple: "",
                                  expanded: "",
                                },
                                model: {
                                  value: _vm.files,
                                  callback: function ($$v) {
                                    _vm.files = $$v
                                  },
                                  expression: "files",
                                },
                              },
                              [
                                _c(
                                  "section",
                                  {
                                    staticClass:
                                      "small-padding has-text-centered",
                                  },
                                  [
                                    _c("p", { staticClass: "is-size-7" }, [
                                      _c("i", { staticClass: "fas fa-plus" }),
                                      _vm._v(
                                        " Arrastre más archivos o haga clic\n                "
                                      ),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.canAsociarAspectos
          ? _c("div", [
              !_vm.isUploading && !_vm.isDone
                ? _c(
                    "div",
                    { staticClass: "field" },
                    [
                      _c(
                        "b-checkbox",
                        {
                          attrs: { size: "is-medium", "native-value": true },
                          model: {
                            value: _vm.habilitarAspectos,
                            callback: function ($$v) {
                              _vm.habilitarAspectos = $$v
                            },
                            expression: "habilitarAspectos",
                          },
                        },
                        [
                          _c("label", { staticClass: "label" }, [
                            _vm._v("Definir aspectos iniciales"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.habilitarAspectos && !_vm.isUploading && !_vm.isDone
                ? _c(
                    "div",
                    { staticClass: "field aspectos-border" },
                    _vm._l(_vm.aspectosDisponibles, function (aspecto) {
                      return _c(
                        "div",
                        { key: aspecto.id },
                        [
                          _c(
                            "b-checkbox",
                            {
                              attrs: {
                                size: "is-small",
                                "native-value": aspecto.id,
                              },
                              model: {
                                value: _vm.aspectosSeleccionados,
                                callback: function ($$v) {
                                  _vm.aspectosSeleccionados = $$v
                                },
                                expression: "aspectosSeleccionados",
                              },
                            },
                            [_vm._v(_vm._s(aspecto.nombre))]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.isUploading && !_vm.isDone
      ? _c("footer", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "card-footer-item has-text-weight-bold is-uppercase",
              attrs: { disabled: _vm.files.length == 0 },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.submit.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "fas fa-upload" }), _vm._v(" Cargar")]
          ),
        ])
      : !_vm.isUploading && _vm.isDone
      ? _c("footer", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cerrar")]
          ),
        ])
      : _vm.isUploading
      ? _c("footer", { staticClass: "card-footer" }, [_vm._m(2)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [
        _vm._v("Subir documentos"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("td", { attrs: { colspan: "3" } }, [
      _c("i", [_vm._v("- No hay archivos para subir -")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      {
        staticClass: "card-footer-item animated flash slow",
        attrs: { type: "button" },
      },
      [
        _c("i", { staticClass: "fas fa-sync fa-spin" }),
        _vm._v(" Subiendo archivos"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }